<div *ngIf="showSpinner" class="overlay" @delayedShow>
  <mat-progress-spinner diameter="50" mode="indeterminate">
  </mat-progress-spinner>
</div>
